// Brand assets (black / white / silver). Provided by FORMAeSALUTE.
// Trimmed to remove transparent padding so they render crisply at small heights.
// logo-dark = black wordmark (use on light surfaces)
// logo-light = white wordmark (use on dark surfaces)
export const LOGO_DARK = "/brand/logo-dark-trim.png";
export const LOGO_LIGHT = "/brand/logo-light-trim.png";
